import ReactCurrencyFormat from 'react-currency-format';

export default function CurrencyFormat({ price, className = '' }) {
  const value = price >= 0 ? Number.parseFloat(price).toFixed(2) : price;
  return (
    <ReactCurrencyFormat
      value={value}
      displayType="text"
      thousandSeparator
      prefix="$"
      renderText={(formattedPrice) => (
        <p className={`precio ${className}`}>{formattedPrice}</p>
      )}
    />
  );
}
